import { report } from './report';
import StReportSdk from '@xfe/st-report-sdk';
import createTracker from './tracker';

const $$tracker = createTracker(report, StReportSdk.getDiffRouteTime);

export default $$tracker;



// WEBPACK FOOTER //
// ./src/$$tracker/index.js